export const Tests = {
  children: [
    'one',
    'two',
  ],
  childProps: {
    onClick: (ev, el, s) => {
        s.update({
          act: el.text
        })
      },
    '.isAct': {
      color: 'red',
      textDecoration: 'underline',
    },
  },
};